export const MAIN_STEPS = 5

export const PROGRESS = {
    START: 0,
    FIRST_SECTION: 25,
    SECOND_SECTION: 30,
    SECOND_SECTION_2: 37,
    SECOND_SECTION_3: 44,
    SECOND_SECTION_4: 50,
    THIRD_SECTION: 52,
    THIRD_SECTION_2: 65,
    FOURTH_SECTION: 68,
    FOURTH_SECTION_2: 74,
    FOURTH_SECTION_3: 80,
    FOURTH_SECTION_4: 86,
    FOURTH_SECTION_5: 92,
    FOURTH_SECTION_6: 98,
    COMPLETE: 100,
} as const

export const PROGRESS_LINE = {
    COMPLETE_ADJUST: 2,
    DEFAULT_ADJUST: 1,
} as const

export const OCCUPATION_DATA = {
    "店舗運営・接客系": [
        { name: "店長・店長候補", occupationId: 1 },
        { name: "レストランサービス・ホールスタッフ", occupationId: 2 },
        { name: "販売スタッフ", occupationId: 17 },
        { name: "女将・和装ホール", occupationId: 26 },
        { name: "レセプション・レストランレセプション", occupationId: 18 },
        { name: "バトラー・ルームサービス", occupationId: 32 },
        { name: "ルームサービス", occupationId: 32 },
        { name: 'レストラン予約管理', occupationId: 35 },
    ],
    "調理・キッチン系": [
        { name: "料理長・料理長候補", occupationId: 2 },
        { name: "キッチンスタッフ", occupationId: 4 },
        { name: "調理見習い・調理補助", occupationId: 5 },
        { name: "栄養士・管理栄養士", occupationId: 25 },
        { name: "寿司職人", occupationId: 6 },
        { name: "鉄板調理", occupationId: 7 },
        { name: "うどん職人・そば職人", occupationId: 8 },
        { name: "天ぷら職人", occupationId: 9 },
        { name: "焼き鳥職人", occupationId: 10 },
        { name: "パティシエ", occupationId: 11 },
        { name: "ブーランジェ・ベーカー", occupationId: 12 },
        { name: "ピッツァイオーロ", occupationId: 16 },
        { name: "スチュワード・洗い場", occupationId: 36 },
    ],
    "料飲・サービス系": [
        { name: "バリスタ", occupationId: 15 },
        { name: "ソムリエ", occupationId: 13 },
        { name: "バーテンダー", occupationId: 14 },
    ],
    "宴会・企画系": [
        { name: "宴会調理", occupationId: 43 },
        { name: "商品開発", occupationId: 22 },
        { name: "ウェディングプランナー", occupationId: 24 },
    ],
    "製造・教育系": [
        { name: "生産加工（精肉・鮮魚・青果など）", occupationId: 27 },
        { name: "スーパーフロア・小売", occupationId: 28 },
        { name: "スクール講師", occupationId: 29 },
    ],
    "管理・運営系": [
        { name: "スーパーバイザー", occupationId: 19 },
        { name: "本部スタッフ", occupationId: 20 },
        { name: "エリアマネージャー", occupationId: 21 },
        { name: "営業管理職・経営幹部", occupationId: 23 },
    ],
    その他: [{ name: "その他(仕事内容)", occupationId: 30 }],
}

export const CUISINE_DATA = {
    和食: [
        { name: "和食", genreId: 5 },
        { name: "日本料理・懐石料理", genreId: 6 },
        { name: "寿司・鮨", genreId: 7 },
        { name: "うどん・そば", genreId: 8 },
    ],
    洋食: [
        { name: "洋食・西洋料理", genreId: 4 },
        { name: "イタリアン", genreId: 1 },
        { name: "フレンチ", genreId: 2 },
        { name: "スペイン料理", genreId: 3 },
        { name: "ステーキ・鉄板焼き", genreId: 14 },
    ],
    "居酒屋・ダイニングバー": [
        { name: "居酒屋", genreId: 11 },
        { name: "バル・バー", genreId: 15 },
        { name: "創作・ダイニングバー", genreId: 16 },
        { name: "焼き鳥", genreId: 10 },
    ],
    "カフェ・ファストフード": [
        { name: "カフェ", genreId: 20 },
        { name: "ファストフード", genreId: 26 },
        { name: "ファミレス", genreId: 27 },
    ],
    "パティスリー・ベーカリー": [
        { name: "パティスリー・ケーキ屋", genreId: 21 },
        { name: "ベーカリー・ブーランジェリー", genreId: 22 },
    ],
    "給食・食堂など": [
        { name: "給食・社員食堂・介護・病院", genreId: 28 },
        { name: "テイクアウト・惣菜・弁当屋", genreId: 30 },
        { name: "集団調理・ケータリング", genreId: 24 },
    ],
    アジア料理: [
        { name: "中華料理・中国料理", genreId: 17 },
        { name: "アジア料理・エスニック", genreId: 19 },
    ],
    "お好み焼き・串揚げ": [
        { name: "お好み焼き・たこ焼き・もんじゃ焼き", genreId: 13 },
        { name: "串カツ・串揚げ", genreId: 12 },
    ],
    "ホテル・ブライダル": [
        { name: "ホテル・旅館", genreId: 23 },
        { name: "ブライダル", genreId: 25 },
    ],
    その他: [
        { name: "ラーメン", genreId: 18 },
        { name: "焼肉", genreId: 9 },
        { name: "専門店(各国料理)", genreId: 29 },
        { name: "その他(料理ジャンル)", genreId: 31 },
    ],
}

export const STEPS = {
    WORKING_STATUS: 0,
    EXPERIENCE_YEARS: 1,
    SEX: 2,
    BIRTHDAY: 3,
    PREFECTURE: 4,
    FULL_NAME: 5,
    TEL: 6,
    LOGIN_INFORMATION: 7,
    COMPANY_NAME: 8,
    EMPLOYMENT_STATUS: 9,
    ENROLLMENT_PERIOD: 10,
    CUISINE_GENRE: 11,
    JOB_CONTENT: 12,
    DETAILED_WORK_DETAILS: 13,
    CONTENT_CONFIRMATION: 14,
} as const

export const STEP_ICONS = {
    0: "/foodslaboEf/img/ProgressBanner/status-icon.png",
    1: "/foodslaboEf/img/ProgressBanner/basic-information-icon.png",
    2: "/foodslaboEf/img/ProgressBanner/contact-icon.png",
    3: "/foodslaboEf/img/ProgressBanner/history-icon.png",
    4: "/foodslaboEf/img/ProgressBanner/confirmation-icon.png",
} as const

export const STEP_TEXT_MAP = {
    [STEPS.WORKING_STATUS]: "現在のステータス 1/2",
    [STEPS.EXPERIENCE_YEARS]: "現在のステータス 2/2",
    [STEPS.SEX]: "基本情報 1/4",
    [STEPS.BIRTHDAY]: "基本情報 2/4",
    [STEPS.PREFECTURE]: "基本情報 3/4",
    [STEPS.FULL_NAME]: "基本情報 4/4",
    [STEPS.TEL]: "連絡先 1/2",
    [STEPS.LOGIN_INFORMATION]: "連絡先 2/2",
    [STEPS.COMPANY_NAME]: "職歴 1/6",
    [STEPS.EMPLOYMENT_STATUS]: "職歴 2/6",
    [STEPS.ENROLLMENT_PERIOD]: "職歴 3/6",
    [STEPS.CUISINE_GENRE]: "職歴 4/6",
    [STEPS.JOB_CONTENT]: "職歴 5/6",
    [STEPS.DETAILED_WORK_DETAILS]: "職歴 6/6",
    [STEPS.CONTENT_CONFIRMATION]: "内容の確認",
} as const

const PREFECTURE_TOKYO = 13
const PREFECTURE_KANAGAWA = 14
const PREFECTURE_CHIBA = 12
const PREFECTURE_SAITAMA = 11
const PREFECTURE_TOCHIGI = 9
const PREFECTURE_GUNMA = 10
const PREFECTURE_IBARAKI = 8
const PREFECTURE_AOMORI = 2
const PREFECTURE_IWATE = 3
const PREFECTURE_AKITA = 5
const PREFECTURE_YAMAGATA = 6
const PREFECTURE_FUKUSHIMA = 7
const PREFECTURE_NIIGATA = 15
const PREFECTURE_TOYAMA = 16
const PREFECTURE_ISHIKAWA = 17
const PREFECTURE_FUKUI = 18
const PREFECTURE_YAMANASHI = 19
const PREFECTURE_NAGANO = 20
const PREFECTURE_HOKKAIDO = 1
const PREFECTURE_OSAKA = 27
const PREFECTURE_HYOGO = 28
const PREFECTURE_KYOTO = 26
const PREFECTURE_NARA = 29
const PREFECTURE_SHIGA = 25
const PREFECTURE_WAKAYAMA = 30
const PREFECTURE_TOTTORI = 31
const PREFECTURE_SHIMANE = 32
const PREFECTURE_OKAYAMA = 33
const PREFECTURE_HIROSHIMA = 34
const PREFECTURE_TOKUSHIMA = 36
const PREFECTURE_KAGAWA = 37
const PREFECTURE_EHIME = 38
const PREFECTURE_KOCHI = 39
const PREFECTURE_AICHI = 23
const PREFECTURE_GIFU = 21
const PREFECTURE_MIE = 24
const PREFECTURE_SHIZUOKA = 22
const PREFECTURE_YAMAGUCHI = 35
const PREFECTURE_FUKUOKA = 40
const PREFECTURE_SAGA = 41
const PREFECTURE_NAGASAKI = 42
const PREFECTURE_KUMAMOTO = 43
const PREFECTURE_OITA = 44
const PREFECTURE_MIYAZAKI = 45
const PREFECTURE_KAGOSHIMA = 46
const PREFECTURE_OKINAWA = 47
const PREFECTURE_MIYAGI = 4

export const AREA_PREFECTURES = {
    main: [
        PREFECTURE_TOKYO,
        PREFECTURE_KANAGAWA,
        PREFECTURE_CHIBA,
        PREFECTURE_SAITAMA,
        PREFECTURE_TOCHIGI,
        PREFECTURE_GUNMA,
        PREFECTURE_IBARAKI,
        PREFECTURE_AOMORI,
        PREFECTURE_IWATE,
        PREFECTURE_AKITA,
        PREFECTURE_YAMAGATA,
        PREFECTURE_FUKUSHIMA,
        PREFECTURE_NIIGATA,
        PREFECTURE_TOYAMA,
        PREFECTURE_ISHIKAWA,
        PREFECTURE_FUKUI,
        PREFECTURE_YAMANASHI,
        PREFECTURE_NAGANO,
    ],
    hokkaido: [PREFECTURE_HOKKAIDO],
    kansai: [
        PREFECTURE_OSAKA,
        PREFECTURE_HYOGO,
        PREFECTURE_KYOTO,
        PREFECTURE_NARA,
        PREFECTURE_SHIGA,
        PREFECTURE_WAKAYAMA,
        PREFECTURE_TOTTORI,
        PREFECTURE_SHIMANE,
        PREFECTURE_OKAYAMA,
        PREFECTURE_HIROSHIMA,
        PREFECTURE_TOKUSHIMA,
        PREFECTURE_KAGAWA,
        PREFECTURE_EHIME,
        PREFECTURE_KOCHI,
    ],
    nagoya: [
        PREFECTURE_AICHI,
        PREFECTURE_GIFU,
        PREFECTURE_MIE,
        PREFECTURE_SHIZUOKA,
    ],
    fukuoka: [
        PREFECTURE_YAMAGUCHI,
        PREFECTURE_FUKUOKA,
        PREFECTURE_SAGA,
        PREFECTURE_NAGASAKI,
        PREFECTURE_KUMAMOTO,
        PREFECTURE_OITA,
        PREFECTURE_MIYAZAKI,
        PREFECTURE_KAGOSHIMA,
        PREFECTURE_OKINAWA,
    ],
    sendai: [PREFECTURE_MIYAGI],
} as const

export const MONTHS = {
    MIN: 1,
    MAX: 12,
}

export const ALPHABET_PAD_LENGTH = 2

export const PASSWORD_CONSTRAINTS = {
    MIN_LENGTH: 8,
    MAX_LENGTH: 32,
}

export const ZIPCODE_LENGTH = {
    MIN: 7,
    MAX: 8,
}

export const TEL_LENGTH = {
    MIN: 10,
    MAX: 11,
}

export const AB_TEST_THRESHOLD = 5

export const DATE_CONSTANTS = {
    MONTH_START_PAD: 2,
    DATE_SLICE_END: 10,
}

export const STEP_GROUPS = {
    FIRST: 0,
    SECOND: 1,
    THIRD: 2,
    FOURTH: 3,
    FIFTH: 4,
} as const

export const TRANSLATION_PERCENTAGE = 100

export const VALIDATION_MESSAGES = {
    INVALID_VALUE: "年と月を入力してください。",
    INVALID_NUMBER: "年と月には数字を入力してください。",
    INVALID_MONTH_RANGE: "月は1〜12の範囲で入力してください。",
    INVALID_DATE: "無効な日付です。",
    AGE_TOO_YOUNG: "14歳未満の方は登録できません。",
    AGE_TOO_OLD: "120歳を超える年齢は入力できません。",
} as const

export const AGE_LIMITS = {
    MIN: 14,
    MAX: 120,
} as const

export const DETAILED_JOB_DETAILS_MIN_LENGTH = 10
export const DETAILED_JOB_DETAILS_MAX_LENGTH = 5000
